import React from 'react';
import 'metanav-ui_library_preact';
import { PRIVACY_POLICY_LINK } from '../../constants/settings.constants';

const FOOTER_CONFIG = {
  text: '© 2022 Stad Antwerpen',
  firstLinkLabel: 'Privacy',
  firstLink: PRIVACY_POLICY_LINK
};

const SPOFooter = () => {
  return <mtn-footer webcomponent config={JSON.stringify(FOOTER_CONFIG)}></mtn-footer>;
};

export default SPOFooter;
